import MUIGrid from "@mui/material/Grid";

const Grid = MUIGrid;

export default Grid;
